<div>
  <div class="manage-users-headers">
    <div class="page-title">Manage Users</div>
    @if (users.length > 0) {
      <div class="page-size">
        <app-page-size
          [pageSize]="pageSize"
          [selectId]="'user-list'"
          (pageSizeChanged)="onPageSizeChange($event)"
        ></app-page-size>
      </div>
    }
  </div>
  <div class="tabs-container">
    <div class="tabs">
      <button
        class="tab"
        [class.active]="activeTab === 'organization'"
        (click)="onTabChange('organization')"
      >
        Organization
      </button>
      <button
        class="tab"
        [class.active]="activeTab === 'sme'"
        (click)="onTabChange('sme')"
      >
        SME
      </button>
    </div>
  </div>
  <div class="top-section">
    <div class="filter-search-section">
      <div class="page-filter">
        @if (activeTab === "organization") {
          <app-filter
            [filterBy]="filterBy"
            [filterByOptions]="filterByOptions"
            (filterByChanged)="onFilterByChange($event)"
          ></app-filter>
        }
      </div>
      <div class="search-section-wrapper">
        <app-search-input
          [placeholder]="'Search ...'"
          [(searchQuery)]="searchText"
          (searchQueryChange)="onSearchInputChange($event)"
        ></app-search-input>
      </div>
    </div>
  </div>
  <app-table
    [columns]="tableColumns"
    [data]="filteredUsers"
    [loading]="loading"
    [noResultsMessage]="'No users found.'"
    [skeletonRows]="3"
  >
    <ng-template let-user>
      <tr>
        <td>
          <div class="profile-section">
            <div
              class="profile-picture"
              [class.no-image]="user.profile_image_path === null"
            >
              @if (user.profile_image_path !== null) {
                <img
                  [src]="getImageUrl(user.profile_image_path)"
                  alt="Profile"
                  class="profile-image"
                />
              }
              <span class="fallback-text">
                {{ user.first_name?.charAt(0)?.toUpperCase() }}
              </span>
            </div>
            <div class="profile-name">
              <div class="name">{{ user.first_name }} {{ user.last_name }}</div>
              <div class="added-on">
                Added on {{ user.date_joined | date: "medium" }}
              </div>
            </div>
          </div>
        </td>
        <td>{{ user.email }}</td>
        <td>
          <a
            href="javascript:void(0);"
            class="connection-tag"
            [style]="{
              'background-color':
                this.connectionColors[user.connection_display_name] || '#ddd',
            }"
            title="{{ user.connection_display_name }}"
          >
            {{ user.connection_display_name }}
          </a>
        </td>
        <td style="color: #6b7280; font-size: 0.875rem">
          {{ user.last_login | date: "medium" }}
        </td>
        <td>
          <div class="action-icons">
            <a
              href="javascript:void(0)"
              (click)="
                viewUserDetails(
                  user,
                  this.connectionColors[user.connection_display_name] || '#ddd'
                )
              "
            >
              View
            </a>
          </div>
        </td>
      </tr>
    </ng-template>
  </app-table>
</div>

@if (users.length > 0) {
  <app-pagination
    [currentPage]="currentPage"
    [pageSize]="pageSize"
    [totalItems]="totalUsers"
    (pageChanged)="onPageChange($event)"
  ></app-pagination>
}

@if (showUserDetailsPopup) {
  <app-secondary-popup
    [title]="'User Details'"
    [isActionButtonsAvailable]="false"
    (popupClosed)="onCloseUserDetailsPopup($event)"
  >
    <app-user-details
      [user]="selectedUser"
      [tagColour]="selectedTagColour"
    ></app-user-details>
  </app-secondary-popup>
}
